import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppList from './AppList'
import AppDetails from './AppDetails'
import Refresh from './Refresh'
import styles from '../bigScreen.less'

function EnterpriseApp(props) {
    const { model, data, cloudId, refreshClick, getBizData, getLangMsg } = props
    const defaultappdid = data?.defaultappid || ''
    const appList = data?.apps || []
    const app = data?.App || {}
    const bizModelTempTotal = data?.Common?.BizModelTemp || 0
    const processValue = data?.p || 0
    const refreshTime = data?.t || ''
    const lastUpdateTime = data?.lastUpdateTime || ''
    const appName = getLangMsg('enterpriseApp.key0001')
    return (
        <div className={styles.enterpriseApp}>
            <div className={styles.appName}>{appName + '(' + appList.length + ')'}</div>
            <Refresh model={model} getLangMsg={getLangMsg} cloudId={cloudId} processValue={processValue} refreshTime={refreshTime} refreshClick={refreshClick} lastUpdateTime={lastUpdateTime} pageState={props.pageState}/>
            <div className={styles.appContainerWrapper}>
                <div className={styles.appContainer}>
                    <AppList model={model} getLangMsg={getLangMsg} appList={appList} defaultappdid={defaultappdid} getBizData={getBizData} />
                    <AppDetails model={model} getLangMsg={getLangMsg} app={app} bizModelTempTotal={bizModelTempTotal} />
                </div>
            </div>
        </div>
    )
}
EnterpriseApp.propTypes = {
    baseinfo: PropTypes.object,
    name: PropTypes.string
}
export default EnterpriseApp;